import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import styled from 'styled-components';

interface IToggleItem {
  value: string | number | boolean;
  label: string;
  disabled?: boolean;
  tooltip?: string;
}
interface IToggleGroupProps {
  value: string | number | boolean;
  onChange: (event: React.MouseEvent<HTMLElement>, value: string | number | boolean) => void;
  data: IToggleItem[];
  name?: string;
  width?: number;
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup)<{ $width: number }>`
  height: 25px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #818e9b;
  width: ${props => props.$width}px;
`;

const StyledToggleButton = styled(ToggleButton)`
  font-family: Segoe UI, sans-serif;
  height: 100%;
  border: none;
  border-radius: 0;
  font-weight: 600;
  font-size: 12px;
  padding: 0 6px;
  justify-content: center;
  width: 100%;
  &.Selected {
    background-color: #2ea1f8;
    color: #ffffff;
    &:hover {
      color: #2ea1f8;
    }
  }
`;

export const ToggleGroup = (props: IToggleGroupProps) => {
  const { value, name, onChange, data, width = 150 } = props;
  return (
    <StyledToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      data-name={name}
      $width={width}>
      {data.map(item => {
        const toggleButton = (
          <StyledToggleButton
            value={item.value}
            disabled={item.disabled}
            classes={{
              selected: 'Selected',
            }}>
            {item.label}
          </StyledToggleButton>
        );
        if (!item.tooltip) {
          return React.cloneElement(toggleButton, { key: item.label });
        }
        return (
          <Tooltip key={item.label} title={item.tooltip} placement="top" arrow>
            <span>{toggleButton}</span>
          </Tooltip>
        );
      })}
    </StyledToggleButtonGroup>
  );
};
